import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import React, { useState } from "react";
import { observer, Observer } from "mobx-react";
import GlobalStyles from "../../../Resources/Styles";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import { Ionicons } from "@expo/vector-icons";
import { Entypo } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";
import { Menu, MenuItem } from "react-native-material-menu";
import { useScreenDimensions, useDevice } from "../../_layout";

import CustomAlert from "../../Components/CustomAlert";
import { useTranslation } from "react-i18next";

import IconEmptyView from "../../Components/IconEmptyView";
import AddFormView from "../../Form/AddFormView";
import SearchBar from "../../Components/SearchBar";
import CTAButton from "../../Components/CTAButton";
import TutorialLinkSection from "../../Components/TutorialLinkSection";

const FormLibrary = ({ coach }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const [showingAddNewForm, setShowingAddNewForm] = useState(false);
  const [showingEditForm, setShowingEditForm] = useState(false);

  const FormListLayout = observer(({ type }) => {
    const FormRow = observer(({ form }) => {
      const isDefault =
        form.type === "Semanal"
          ? coach.weeklyFormId === form.id.toString().toLowerCase()
          : coach.blockFormId === form.id.toString().toLowerCase();
      const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
      const deleteAlertTitle = "deleteFormAlertTitle-string";
      const deleteAlertText = "deleteFormAlertText-string";

      const [showingMakePredefinedAlert, setShowingMakePredefinedAlert] =
        useState(false);
      const makePredefinedAlertTitle = "setDefaultFormAlertTitle-string";
      const makePredefinedAlertText = "setDefaultFormAlertText-string";

      const [workoutMenu, setWorkoutMenu] = useState(false);
      const [isHovered, setIsHovered] = useState(false);

      const showWorkoutMenu = () => {
        if (!coach.isOffline) {
          setWorkoutMenu(true);
        }
      };

      const action = () => {
        if (!coach.isOffline) {
          form.setProperty("isSelected", true);
          setShowingEditForm(true);
        }
      };

      const showMakeDefault = () => {
        setShowingMakePredefinedAlert(true);
        setWorkoutMenu(false);
        setIsHovered(false);
      };
      const makeFormPredefined = () => {
        if (form.type === "Semanal") {
          coach.setProperty("weeklyFormId", form.id.toString().toLowerCase());
        } else {
          coach.setProperty("blockFormId", form.id.toString().toLowerCase());
        }
        coach.updateCoachTransactionForms(form.id);
        coach.startOrResetBatchTimer();
        setWorkoutMenu(false);
      };

      const showDeleteAlert = () => {
        setShowingDeleteAlert(true);
        setWorkoutMenu(false);
      };
      const deleteForm = () => {
        coach.deleteForm(form);
        setWorkoutMenu(false);
      };

      return (
        <View
          style={{
            width: `calc((100% - ${screenSize === "small" ? 8 : 24}px) / ${
              screenSize === "small" ? 2 : 3
            })`,
          }}
        >
          <TouchableOpacity
            onPress={action}
            style={[
              GlobalStyles.touchableRow,
              {
                shadowColor: Colors.bubbleColor,
                borderWidth: isDefault ? 1 : 0.1,
                borderColor: isDefault
                  ? isHovered
                    ? Colors.blackColor
                    : Colors.grayColor
                  : isHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
                opacity: coach.isOffline ? 0.5 : 1,
                marginBottom: 0,
              },
            ]}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={{
                justifyContent: "center",
                flex: 1,
                height: "100%",
                gap: 8,
              }}
            >
              <Text
                numberOfLines={1}
                style={[
                  Fonts.medium14,
                  {
                    flexShrink: 1,
                  },
                ]}
              >
                {form.name}
              </Text>
              <View
                style={[
                  GlobalStyles.HStack,
                  {
                    width: "100%",
                    flexWrap: "wrap",
                    maxHeight: 32,
                    overflow: "hidden",
                  },
                ]}
              >
                {isDefault && screenSize !== "small" && (
                  <Text
                    style={[
                      GlobalStyles.rowSubText,
                      { flexShrink: 1, minWidth: 0 },
                    ]}
                    numberOfLines={1}
                  >
                    {t("default-string")}
                  </Text>
                )}
                <View
                  style={[GlobalStyles.HStack, { flexShrink: 1, minWidth: 0 }]}
                >
                  <FontAwesome5
                    name="clipboard-list"
                    size={12}
                    color={Colors.bubbleColor}
                    style={GlobalStyles.rowIcon}
                  />
                  <Text
                    style={[
                      GlobalStyles.rowSubText,
                      { flexShrink: 1, minWidth: 0 },
                    ]}
                    numberOfLines={1}
                  >
                    {form.numberOfQuestionsAsked === 1
                      ? t("questionCountOne-string", {
                          count: form.numberOfQuestionsAsked,
                        })
                      : t("questionCount-string", {
                          count: form.numberOfQuestionsAsked,
                        })}
                  </Text>
                </View>

                {form.type !== "Inicial" && screenSize !== "small" && (
                  <View
                    style={[
                      GlobalStyles.HStack,
                      { flexShrink: 1, minWidth: 0 },
                    ]}
                  >
                    <Ionicons
                      name="person"
                      size={12}
                      color={Colors.bubbleColor}
                      style={GlobalStyles.rowIcon}
                    />
                    <Text
                      style={[
                        GlobalStyles.rowSubText,
                        { marginRight: 0, flexShrink: 1, minWidth: 0 },
                      ]}
                      numberOfLines={1}
                    >
                      {coach.clientsInForm(form).length === 1
                        ? t("athleteCountOne-string", {
                            count: coach.clientsInForm(form).length,
                          })
                        : t("athleteCount-string", {
                            count: coach.clientsInForm(form).length,
                          })}
                    </Text>
                  </View>
                )}
              </View>
            </View>
            {form.type !== "Inicial" && (
              <Menu
                visible={workoutMenu}
                anchor={
                  <TouchableOpacity onPress={showWorkoutMenu}>
                    <Entypo
                      name="dots-three-horizontal"
                      size={22}
                      color={isHovered || isMobile ? "black" : "transparent"}
                    />
                  </TouchableOpacity>
                }
                style={[
                  GlobalStyles.menu,
                  { width: screenSize === "small" ? "auto" : "auto" },
                ]}
                onRequestClose={() => setWorkoutMenu(false)}
              >
                {form.type === "Semanal" ? (
                  <>
                    {coach.weeklyFormId !==
                      form.id.toString().toLowerCase() && (
                      <MenuItem
                        onPress={showMakeDefault}
                        style={{ minWidth: 220 }}
                        textStyle={{ fontSize: 14 }}
                      >
                        {t("setAsDefault-string")}
                      </MenuItem>
                    )}
                  </>
                ) : (
                  <>
                    {coach.blockFormId !== form.id.toString().toLowerCase() && (
                      <MenuItem
                        onPress={showMakeDefault}
                        style={{ minWidth: 220 }}
                        textStyle={{ fontSize: 14 }}
                      >
                        {t("setAsDefault-string")}
                      </MenuItem>
                    )}
                  </>
                )}

                <MenuItem
                  onPress={showDeleteAlert}
                  style={{ minWidth: 150 }}
                  textStyle={{ fontSize: 14, color: "red" }}
                >
                  {t("delete-string")}
                </MenuItem>
              </Menu>
            )}
          </TouchableOpacity>
          {showingDeleteAlert && (
            <CustomAlert
              isVisible={showingDeleteAlert}
              onClose={() => setShowingDeleteAlert(false)}
              title={deleteAlertTitle}
              text={deleteAlertText}
              action={deleteForm}
              specialCTA={"delete-string"}
            />
          )}
          {showingMakePredefinedAlert && (
            <CustomAlert
              isVisible={showingMakePredefinedAlert}
              onClose={() => setShowingMakePredefinedAlert(false)}
              title={makePredefinedAlertTitle}
              text={makePredefinedAlertText}
              action={makeFormPredefined}
              specialCTA={"set-string"}
            />
          )}
        </View>
      );
    });
    return (
      <>
        <View style={[GlobalStyles.HStack, { marginBottom: 2 }]}>
          <Text
            style={{
              fontSize: 13,
              fontWeight: "600",
              textTransform: "uppercase",
              letterSpacing: 0.5,
              color: Colors.darkgrayColor,
            }}
          >
            {type === "Inicial"
              ? t("initialForm-string")
              : type === "Semanal"
              ? t("weeklyForms-string")
              : t("blockForms-string")}
          </Text>
        </View>
        {coach.getFilteredFormLibrary(type).length === 0 &&
        coach.searchTermFormLibrary === "" ? (
          <IconEmptyView
            iconLibrary={"Ionicons"}
            mainText={
              type === "Semanal"
                ? "withoutWeeklyForms-string"
                : "withoutBlockForms-string"
            }
            subText={
              type === "Semanal"
                ? "createWeeklyForms-string"
                : "createBlockForms-string"
            }
            iconName={type === "Semanal" ? "calendar-outline" : "clipboard-outline"}
            marginTop={32}
            marginBottom={16}
          />
        ) : (
          <View
            style={{
              flexDirection: "row",
              justifyContent: "flex-start",
              flexWrap: "wrap",
              marginTop: 8,
              marginBottom: screenSize === "small" ? 16 : 24,
              gap: screenSize === "small" ? 8 : 12,
            }}
          >
            {coach.getFilteredFormLibrary(type).map((form) => {
              return <FormRow form={form} key={form.id} />;
            })}
          </View>
        )}
      </>
    );
  });

  return (
    <View
      style={[
        styles.container,
        { marginTop: screenSize === "small" ? 16 : 24 },
      ]}
    >
      <Observer>
        {() => (
          <>
            <View
              style={[
                GlobalStyles.HStack,
                {
                  marginBottom: screenSize === "small" ? 16 : 24,
                  maxWidth: "45%",
                },
              ]}
            >
              <SearchBar
                text={coach.searchTermFormLibrary}
                onChangeText={(text) =>
                  coach.setProperty("searchTermFormLibrary", text)
                }
                placeholder={"searchForm-string"}
                autoFocusOnDesktop={true}
              />
              <CTAButton
                plus={true}
                text={"newForm-string"}
                action={() => {
                  if (!coach.isOffline) {
                    setShowingAddNewForm(true);
                  }
                }}
                disabled={coach.isOffline}
              />
            </View>
            {coach.showFormsLibraryInfoView && (
              <TutorialLinkSection
                text="tutorialLibraryForms-string"
                urlPath="/library/forms"
                marginTop={0}
                marginBottom={screenSize === "small" ? 16 : 24}
              />
            )}
            <FormListLayout type={"Inicial"} />
            <FormListLayout type={"Semanal"} />
            <FormListLayout type={"Fin de bloque"} />

            {showingAddNewForm && (
              <AddFormView
                isVisible={showingAddNewForm}
                onClose={() => setShowingAddNewForm(false)}
                coach={coach}
              />
            )}
            {showingEditForm && coach.selectedForm && (
              <AddFormView
                isVisible={showingEditForm}
                onClose={() => setShowingEditForm(false)}
                coach={coach}
                form={coach.selectedForm}
              />
            )}
          </>
        )}
      </Observer>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.backgroundColor,
  },
});

export default FormLibrary;
